import { useParams } from 'react-router-dom';

export function useRequiredParam(name: string): string {
  const params = useParams();
  const value = params[name];

  if (typeof value !== 'string') {
    throw new Error(`Missing required path parameter: ${name}`);
  }

  return value;
}
